import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="spaces-load-more"
export default class extends Controller {
  static targets = ['btn']

  connect() {
  }

  open(e) {
    e.preventDefault();
    const i = this.btnTarget.dataset.pageNumber;
    const spacePages = document.querySelectorAll('.spaces-search-results');
    spacePages.forEach(page => {
      let pageID = page.dataset.spacePage;
      if(i == pageID){
        page.classList.add('open');
      }
    });
    e.target.style.display = 'none';
  }
}
